import React, { useEffect } from 'react'

export default function Toggle({ object, handleFormData, formUse, data, prefilledData, viewOnly,rowIndex, colIndex }) {

    useEffect(() => {
        formUse && handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, false)
    }, [])

    return (
        <div className='d-flex gap-3 align-items-center justify-content-between' style={{ padding: "8px" }}>
            <label>{object.content}</label>
            <div className="form-switch d-flex">
                <input className="form-check-input" name={object.content}
                    checked={prefilledData && prefilledData[object.content] ? prefilledData[object?.content] : data && data[object.content+"-"+rowIndex+colIndex]}
                    style={{ width: "40px", height: "20px" }} type="checkbox" id="paymentTerms"
                    onChange={(e) => handleFormData && handleFormData(object.content+"-"+rowIndex+colIndex, e.target.checked)}
                    disabled={prefilledData && prefilledData[object?.content] ? true : viewOnly ? viewOnly : false}
                />
            </div>
        </div>
    )
}
